import { type SVGProps } from 'react'

export const ControlsIcon: { __brand: 'color' | 'nocolor' } = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 6.5C11.4477 6.5 11 6.05228 11 5.5V4.5L1.5 4.5L1.39746 4.49512C0.893332 4.44378 0.5 4.01768 0.5 3.5C0.5 2.98232 0.893332 2.55621 1.39746 2.50488L1.5 2.5L11 2.5V1.5C11 0.947715 11.4477 0.5 12 0.5C12.5523 0.500001 13 0.947716 13 1.5V5.5C13 6.05228 12.5523 6.5 12 6.5Z"
        fill="#707070"
      />
      <path
        d="M16 4.5C15.4477 4.5 15 4.05228 15 3.5C15 2.94772 15.4477 2.5 16 2.5H18.5C19.0523 2.5 19.5 2.94772 19.5 3.5C19.5 4.05228 19.0523 4.5 18.5 4.5L16 4.5Z"
        fill="#707070"
      />
      <path
        d="M8 12.5C7.44771 12.5 7 12.0523 7 11.5V7.5C7 6.94772 7.44772 6.5 8 6.5C8.55228 6.5 9 6.94772 9 7.5V8.5H18.5C19.0523 8.5 19.5 8.94772 19.5 9.5C19.5 10.0523 19.0523 10.5 18.5 10.5H9V11.5C9 12.0523 8.55228 12.5 8 12.5Z"
        fill="#707070"
      />
      <path
        d="M1.39746 10.4951C0.893332 10.4438 0.5 10.0177 0.5 9.5C0.5 8.98232 0.893332 8.55621 1.39746 8.50488L1.5 8.5H4C4.55228 8.5 5 8.94772 5 9.5C5 10.0523 4.55228 10.5 4 10.5H1.5L1.39746 10.4951Z"
        fill="#707070"
      />
      <path
        d="M12 18.5C11.4477 18.5 11 18.0523 11 17.5V16.5H1.5L1.39746 16.4951C0.893332 16.4438 0.5 16.0177 0.5 15.5C0.5 14.9823 0.893332 14.5562 1.39746 14.5049L1.5 14.5L11 14.5L11 13.5C11 12.9477 11.4477 12.5 12 12.5C12.5523 12.5 13 12.9477 13 13.5V17.5C13 18.0523 12.5523 18.5 12 18.5Z"
        fill="#707070"
      />
      <path
        d="M15.8975 16.4951C15.3933 16.4438 15 16.0177 15 15.5C15 14.9823 15.3933 14.5562 15.8975 14.5049L16 14.5H18.5C19.0523 14.5 19.5 14.9477 19.5 15.5C19.5 16.0523 19.0523 16.5 18.5 16.5H16L15.8975 16.4951Z"
        fill="#707070"
      />
    </svg>
  )
}

ControlsIcon.__brand = 'nocolor'
